export enum COMPANY_KIND {
  COMPANY_BY_SHARES = 1,
  INDIVIDUAL_LIMITED_LIABILITY_COMPANY = 2,
  LIMITED_LIABILITY_COMPANY = 3,
  ANONYMOUS_COMPANY = 4,
  CLOSED_ANONYMOUS_COMPANY = 5,
  NA = 6,
  OTHER = 100,
}

export const STUDY_COMPANY_KINDS = [
  {
    value: COMPANY_KIND.COMPANY_BY_SHARES,
    displayName: 'sociedad por acciones',
  },
  {
    value: COMPANY_KIND.INDIVIDUAL_LIMITED_LIABILITY_COMPANY,
    displayName: 'empresa individual de responsabilidad limitada',
  },
  {
    value: COMPANY_KIND.LIMITED_LIABILITY_COMPANY,
    displayName: 'sociedad de responsabilidad limitada',
  },
  {
    value: COMPANY_KIND.ANONYMOUS_COMPANY,
    displayName: 'sociedad anónima',
  },
  {
    value: COMPANY_KIND.CLOSED_ANONYMOUS_COMPANY,
    displayName: 'sociedad anónima cerrada',
  },
  {
    value: COMPANY_KIND.NA,
    displayName: 'na',
  },
  {
    value: COMPANY_KIND.OTHER,
    displayName: 'otro',
  },
];
